import Vue from 'vue';

const scrollMixin = ({
  data() {
    return {
      scrollTop: 0,
      scrollHeight:0,
      scrollEl:null,
    };
  },
  methods: {
    wikiScroll(e) {
      this.scrollTop = e.target.scrollTop;
      this.scrollHeight = e.target.scrollHeight;
    },
  },
  mounted() {
    if (!this.scrollEl){
      this.scrollEl = this.$el;
    }
    this.scrollEl.scrollTo({
      top: this.scrollTop,
    });
    this.scrollEl.addEventListener('scroll', (e) => this.wikiScroll(e));
  },
  activated() {
    this.scrollEl.scrollTo({
      top: this.scrollTop,
    });
  },
});
export default scrollMixin;
